import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { StyledChartCardBodyWrapper } from '../../../../components/ChartCard/styles';
import { StyledChartWrapper, StyledPickerHeader } from '../styles';

export const StyledPreviewCardOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
  z-index: 1;
  background: rgba(255, 255, 255, 0.45);
  border-radius: 6px;
`;

export const StyledPreviewApplyButton = styled.span`
  padding: 8px 32px;
  border-radius: 25px;
  background: ${colorsPalettes.blue[400]};
  ${setFontVariant('button', colorsPalettes.carbon[0])};
`;

export const StyledPreviewsSection = styled.div`
  ${StyledPickerHeader} {
    margin-bottom: 8px;
  }

  ${StyledChartWrapper} {
    margin: 0 0 8px;
    cursor: pointer;
    transition: box-shadow 0.2s;
    border-radius: 6px;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      box-shadow: 0 2px 12px rgba(62, 116, 254, 0.12);

      ${StyledPreviewCardOverlay} {
        opacity: 1;
      }

      ${StyledChartCardBodyWrapper} > :not(${StyledPreviewCardOverlay}) {
        filter: blur(5px);
        transition: filter 0.2s;
      }
    }
  }
`;

export const StyledPreviewsTitle = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[300])};
  margin-bottom: 8px;
`;
